import { UseMutationResult, useMutation } from 'react-query'
import request from '../request'

export const useSignS3LinkForUpload = (): UseMutationResult<
  { uploadUrl: string },
  Error,
  { data: { bucket_name?: string; fileName: string; mimeType: string } },
  unknown
> => {
  return useMutation(
    ({
      data,
    }: {
      data: { bucket_name?: string; fileName: string; mimeType: string }
    }): Promise<{ uploadUrl: string }> =>
      request({
        url: `/utils/assets/sign_url`,
        method: 'POST',
        data,
      }),
  )
}
